import wixData from 'wix-data';
const collectionName = 'AccessoiresReception';
const fieldToFilterByInCollection = 'tags';
 
$w.onReady(function () {
 
    setRepeatedItemsInRepeater();
    loadDataToRepeater();
 
    $w('#filtre3').onChange((event) => {
        const selectedTags = $w('#filtre3').value;
        loadDataToRepeater(selectedTags);
    })
});
 
function loadDataToRepeater(selectedCategories = []) {
 
    let dataQuery = wixData.query(collectionName);
 
    if (selectedCategories.length > 0) {
        dataQuery = dataQuery.hasSome(fieldToFilterByInCollection, selectedCategories);
    }
 
    dataQuery
        .find()
        .then(results => {
            const itemsReadyForRepeater = results.items;
            $w('#repeater3').data = itemsReadyForRepeater;
            const isRepeaterEmpty = itemsReadyForRepeater.length === 0
 
            if (isRepeaterEmpty) {
                $w('#noproduct').show();
            } else {
                $w('#noproduct').hide();
            }
        })
}
 
function setRepeatedItemsInRepeater() {
 
    $w('#repeater3').onItemReady(($item, itemData) => {
        $item('#titre3').text =itemData.nom;
		$item('#decription3').text =itemData.description;
        $item('#image3').src = itemData.image;
        $item('#image3').tooltip = itemData.detail;
        $item('#prix3').text = '€' + itemData.location;
    })
}
